import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { SpinnerService } from "shared-components";
import { EtiquetadoService } from "../../../services/etiquetado.service";

@Component({
    selector: 'app-etq-almacenes',
    templateUrl: './almacenes.component.html'
})
export class AlmacenesEtiquetadorComponent implements OnInit {

    public new = false;
    public almacenEditable;
    public almacenesList;
    private _filters;

    @Input() etiquetadorId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _etiquetadoService: EtiquetadoService
    ) {}

    ngOnInit() {
        this._filters = {
            etiquetadorId: this.etiquetadorId
        };

        this.getAlmacenesEtiquetador();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public getAlmacenesEtiquetador() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.getAlmacenesEtiquetador(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.almacenesList = resp.lista;
        });
    }

    public editableChanged(almacen) {
        this.almacenEditable = almacen;
        this.new = false;
    }

    public toRefresh(value) {
        this.getAlmacenesEtiquetador();
        this.refresh.emit(value);
        this.almacenEditable = '';
        this.new = false;
    }

}
